<template>
  <b-container class="text-center">
    <br /><br />
    <div v-if="data == '' || data == undefined">
      C'è stato un problema, devi accedere dal portale Jointly
    </div>

    <div v-else>
      Accesso in corso...
      <br /><br />
      <Spinner v-if="loading" />
      <!--
            <div v-else>
                <p>jpToken: {{jpToken}}</p>
            </div>
            -->
    </div>
    <br /><br />
  </b-container>
</template>

<script>
import Vue from 'vue';
//import Router from 'vue-router'
import Spinner from '@/components/atoms/spinner';
import { jp_sso } from '@/api';

export default {
  name: 'jp-sso',
  components: {
    Spinner,
  },
  props: {},
  data() {
    return {
      data: '',
      loading: true,
    };
  },
  mounted() {
    let _this = this;

    _this.data = _this.$router.currentRoute.query.data;
    _this.jp_sso();
  },
  methods: {
    jp_sso() {
      let _this = this;

      jp_sso({
        app: Vue.prototype.$config.app,
        data: _this.data,
      }).then((response) => {
        window.location.href = '/?token=' + response.data.token;
      });
    },
  },
};
</script>
